export default "__VITE_ASSET__CGbrwkfT__"